import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UtilsService } from '../../shared/utils.service';
import { GamificationBadgeDto } from '../../shared/types/GamificationBadgeDto';
import {
  GamificationLeaderboardDto,
  GamificationLeaderboardMemberDto,
} from '../../shared/types/GamificationLeaderboardDto';
import { GamificationProfileDto } from '../../shared/types/GamificationProfileDto';
import { OeAppService } from '../../shared/oe-app.service';
import { TranslationService } from '../../shared/translation.service';

@Component({
  selector: 'lp2-active-ticket',
  templateUrl: './active-ticket.component.html',
  styleUrls: ['./active-ticket.component.scss'],
})
export class ActiveTicketComponent implements OnInit, OnDestroy {
  @Input()
  set activityBadgeData(data: GamificationBadgeDto) {
    if (data) {
      this.remainingTime = data.remainingTimeMilliseconds;
      if (this.remainingTime < 1) {
        this.remainingTime = 1;
      }
      this.refreshRemainingTime();
    }
  }

  @Input()
  set leaderboardData(data: GamificationLeaderboardDto) {
    this.leaderboard = data;
    if (data) {
      this.currentLeaderboardUserIndex = data.members.findIndex(
        (e: GamificationLeaderboardMemberDto) => e.currentUser
      );
      this.currentLeaderboardUser =
        data.members[this.currentLeaderboardUserIndex];
    } else {
      this.currentLeaderboardUser = null;
      this.currentLeaderboardUserIndex = 0;
    }
  }

  @Input()
  gamificationProfile: GamificationProfileDto;

  @Output()
  reloadLeaderboard = new EventEmitter();

  leaderboard: GamificationLeaderboardDto;

  currentLeaderboardUser: GamificationLeaderboardMemberDto;

  currentLeaderboardUserIndex = 0;

  remaining: { days: number; hours: number; minutes: number };

  timerSubscription: Subscription;

  remainingTime: number;

  currentLeagueIndex: number;

  gamificationS3Url = `//${this.oeApp.s3BucketHost()}/gamification`;

  language = 'en';

  constructor(
    private oeApp: OeAppService,
    private translationService: TranslationService
  ) {}

  ngOnInit() {
    this.language = this.translationService.getCurrentLanguage();

    this.timerSubscription = interval(1000)
      .pipe(filter(() => this.remainingTime > 0))
      .subscribe(() => {
        if (this.remainingTime === undefined) {
          return;
        }

        this.remainingTime -= 1000;
        if (this.remainingTime > 0) {
          this.refreshRemainingTime();
        } else {
          setTimeout(() => this.reloadLeaderboard.emit(), 5000);
        }
      });
  }

  refreshRemainingTime() {
    if (this.remainingTime > 0) {
      this.remaining = UtilsService.remainingTime(this.remainingTime);
    }
  }

  ngOnDestroy() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/progress/active-ticket/active-ticket.component.ts